import React from 'react';
import { Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

const ExportPDFButton = ({ order, sx = {} }) => {
  const handleExportPDF = () => {
    // Store original title
    const originalTitle = document.title;
    
    // Set document title for PDF filename
    const orderType = order?.order_type || 'Order';
    const orderId = order?.id || 'Unknown';
    document.title = `ComEx_${orderType}_${orderId}`;
    
    // Add print mode class to body
    document.body.classList.add('printing');
    
    // Delay to ensure DOM is ready
    setTimeout(() => {
      window.print();
      
      // Cleanup after print
      setTimeout(() => {
        document.title = originalTitle;
        document.body.classList.remove('printing');
      }, 100);
    }, 100);
  };

  return (
    <Button
      variant="outlined"
      startIcon={<PrintIcon />}
      onClick={handleExportPDF}
      className="no-print"
      fullWidth
      sx={{ 
        textTransform: 'none',
        borderColor: 'primary.main',
        color: 'primary.main',
        '&:hover': {
          borderColor: 'primary.dark',
          backgroundColor: 'primary.lighter'
        },
        // Responsive styling
        width: { xs: '100%', sm: 'auto' },
        minWidth: { xs: '100%', sm: '160px' },
        // Merge with any passed sx props
        ...sx
      }}
    >
      Export to PDF
    </Button>
  );
};

export default ExportPDFButton;